// extracted by mini-css-extract-plugin
export default {"container":"o5D0by5vo5n4TFLydn_k","image":"RxH8xAFEjOjDV3ctxbxd","title":"oreO719TtTlAeHopaswJ","subtitle":"trL1MgKF73vfDzSpLZwS","button":"zHpx8eSPJCBn02L3jM0F"};